import React from 'react'
import classes from "./contactBanner.module.css"
import {  AiFillStar } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux'

const ContactBanner = () => {


  const PF = process.env.REACT_APP_PUBLIC_FOLDER;
  const reduxData = useSelector((state) => state.website);

  const preloadImage = (url) => {
    const img = new Image();
    img.src = url;
  };

  preloadImage(PF + "oldbatch7.jpg")

  const navigate = useNavigate()



  const handleContact = () => {
    //navigate to properties
    navigate(`/contact`)
  }

  const handleSearch = () => {
    navigate(`/properties`);
  };



  const handleAbout = () => {
    navigate(`/about`);
  };


  const handleWhySell = () => {
    navigate(`/whysell`);
  };


  const handleWhyLet = () => {
    navigate(`/whylet`);
  };


  const handleValuation = () => {
    navigate(`/valuation`);
  };



  

  return (
    <div className={classes.container}>
      <div className={classes.abImg}>
      <img src={`https://katteochapi.onrender.com/images/${reduxData.data.contactHeroImg}`} alt="background" />
      </div>
      
        <div className={classes.absolute}>
      <div className={classes.left}>
      <h2>{reduxData.data.contactNumber}
        
        

      </h2>

      <p>{reduxData.data.contactEmail}</p>
      {reduxData.data.contactHeroButtonType === "Properties" && (
            <button onClick={handleSearch} className={classes.valButton} >
              OUR PORTFOLIO
            </button>
          )


          }


          {reduxData.data.contactHeroButtonType === "OurTeam" && (
            <button onClick={handleContact} className={classes.valButton} >
              MEET THE TEAM
            </button>
          )


          }

          {reduxData.data.contactHeroButtonType === "About" && (

            <button onClick={handleAbout} className={classes.valButton} >
              OUR MISSION
            </button>
          )


          }

          {reduxData.data.contactHeroButtonType === "WhyLet" && (
            <button onClick={handleWhyLet} className={classes.valButton} >
              RENT
            </button>

          )

          }

          {reduxData.data.contactHeroButtonType === "WhySell" && (
            <button onClick={handleWhySell} className={classes.valButton} >
              SELL
            </button>

          )


          }

          {reduxData.data.contactHeroButtonType === "Valuation" && (
            <button onClick={handleValuation} className={classes.valButton} >
              GET A VALUATION
            </button>

          )


          }



      </div>
    </div>
    </div>
  )
}

export default ContactBanner